export enum Step {
  MANDATORY = 1,
  OPTIONAL = 2,
  RESULTS = 3,
}
